import './roundSpinner.css'
export default function RoundSpinner(){
    return(
        <div className="roundSpinner"></div>
    )
}